import { useState } from "react";
import { useNavigate } from "react-router-dom";

const pros = [
  {
    id: 1,
    name: "Varnes Total Tree Service",
    rating: 4.9,
    reviews: 312,
    years: 18,
    location: "Los Angeles, CA",
    badge: "Top Rated",
    badgeColor: "bg-green-100 text-green-800",
    verified: true,
    services: ["Tree Trimming", "Tree Removal", "Stump Grinding"],
    description:
      "Family-owned tree service with 18+ years of experience. We specialize in large oak and palm tree trimming throughout the greater LA area. All work is fully insured and backed by a satisfaction guarantee.",
    responseTime: "Responds in ~2 hours",
    avatar: "https://public.readdy.ai/ai/img_res/092739acd939a0e388fce2bb9d2d3d01.jpg",
    price: "Starting at $175",
  },
  {
    id: 2,
    name: "Ari's Treescape Services",
    rating: 4.8,
    reviews: 198,
    years: 12,
    location: "Simi Valley, CA",
    badge: "Angi Approved",
    badgeColor: "bg-amber-100 text-amber-800",
    verified: true,
    services: ["Tree Pruning", "Emergency Removal", "Lot Clearing"],
    description:
      "ISA-certified arborists serving Simi Valley and Ventura County. We handle everything from routine pruning to emergency storm damage removal. Free on-site estimates within 24 hours.",
    responseTime: "Responds in ~4 hours",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arborist%20tree%20company%20logo%20leaf%20design%20clean%20minimal%20white%20background%20green%20colors&width=80&height=80&seq=pro-logo-002&orientation=squarish",
    price: "Starting at $150",
  },
  {
    id: 3,
    name: "B & B Tree Service",
    rating: 4.7,
    reviews: 145,
    years: 9,
    location: "Woodland Hills, CA",
    badge: "Licensed",
    badgeColor: "bg-sky-100 text-sky-800",
    verified: true,
    services: ["Tree Trimming", "Stump Removal", "Tree Health Assessment"],
    description:
      "Woodland Hills' most trusted tree care team. We use the latest equipment and techniques to keep your trees healthy and your property safe. Competitive pricing with no hidden fees.",
    responseTime: "Responds in ~6 hours",
    avatar: "https://readdy.ai/api/search-image?query=tree%20service%20business%20logo%20two%20trees%20silhouette%20clean%20professional%20white%20background%20dark%20green&width=80&height=80&seq=pro-logo-003&orientation=squarish",
    price: "Starting at $200",
  },
  {
    id: 4,
    name: "Abiel and Trees",
    rating: 4.8,
    reviews: 87,
    years: 6,
    location: "Fresno, CA",
    badge: "New on Site",
    badgeColor: "bg-purple-100 text-purple-800",
    verified: true,
    services: ["Tree Trimming", "Palm Tree Service", "Debris Cleanup"],
    description:
      "Fresno's go-to team for palm and fruit tree care. Abiel and his crew are known for meticulous cleanup and fair pricing. Bilingual service available (English/Spanish).",
    responseTime: "Responds in ~3 hours",
    avatar: "https://readdy.ai/api/search-image?query=tree%20trimming%20service%20logo%20palm%20tree%20icon%20clean%20simple%20white%20background%20warm%20green%20tones%20professional&width=80&height=80&seq=pro-logo-004&orientation=squarish",
    price: "Starting at $130",
  },
  {
    id: 5,
    name: "24/7 Tree Services",
    rating: 4.6,
    reviews: 231,
    years: 14,
    location: "Los Angeles, CA",
    badge: "Emergency Ready",
    badgeColor: "bg-red-100 text-red-800",
    verified: true,
    services: ["Emergency Removal", "Storm Damage", "Tree Trimming"],
    description:
      "Available around the clock for emergency tree removal and storm damage response. Fully equipped with cranes and heavy machinery for the toughest jobs in LA County.",
    responseTime: "Responds in ~1 hour",
    avatar: "https://readdy.ai/api/search-image?query=emergency%20tree%20service%20company%20logo%20bold%20red%20and%20green%20design%20clean%20white%20background%20professional&width=80&height=80&seq=pro-logo-005&orientation=squarish",
    price: "Starting at $250",
  },
  {
    id: 6,
    name: "Complete Tree Services",
    rating: 4.9,
    reviews: 403,
    years: 22,
    location: "Los Angeles, CA",
    badge: "Top Rated",
    badgeColor: "bg-green-100 text-green-800",
    verified: true,
    services: ["Full Tree Care", "Removal", "Stump Grinding", "Trimming"],
    description:
      "With over two decades in the business, Complete Tree Services is the most reviewed tree company in LA. We handle residential and commercial projects of any size with precision and care.",
    responseTime: "Responds in ~2 hours",
    avatar: "https://readdy.ai/api/search-image?query=complete%20tree%20services%20professional%20logo%20bold%20green%20tree%20design%20clean%20white%20background%20established%20company&width=80&height=80&seq=pro-logo-006&orientation=squarish",
    price: "Starting at $195",
  },
];

export default function ProListings() {
  const [visibleCount, setVisibleCount] = useState(4);
  const navigate = useNavigate();

  return (
    <section className="bg-[#F7F9F8] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B4332]">
              Tree Service Pros Near You
            </h2>
            <p className="text-gray-500 text-sm mt-1">
              Showing top-rated professionals · Nationwide USA
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500">Sort by:</span>
            <select className="h-9 px-3 pr-8 rounded-lg border border-gray-200 bg-white text-sm text-gray-700 focus:outline-none cursor-pointer appearance-none">
              <option>Top Rated</option>
              <option>Most Reviews</option>
              <option>Lowest Price</option>
              <option>Fastest Response</option>
            </select>
          </div>
        </div>

        {/* Pro Cards */}
        <div className="flex flex-col gap-4">
          {pros.slice(0, visibleCount).map((pro) => (
            <div
              key={pro.id}
              className="bg-white rounded-2xl border border-gray-100 p-5 md:p-6 flex flex-col md:flex-row gap-5 hover:border-[#1B4332]/30 transition-colors"
            >
              {/* Avatar */}
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden flex-shrink-0 bg-gray-50 border border-gray-100">
                <img
                  src={pro.avatar}
                  alt={pro.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="text-base md:text-lg font-bold text-[#1B4332]">{pro.name}</h3>
                  <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap ${pro.badgeColor}`}>
                    {pro.badge}
                  </span>
                  {pro.verified && (
                    <span className="flex items-center gap-1 text-xs text-[#1B4332] font-medium">
                      <i className="ri-shield-check-fill text-green-600"></i> Verified
                    </span>
                  )}
                </div>

                {/* Rating */}
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < Math.floor(pro.rating) ? "ri-star-fill text-amber-400" : "ri-star-line text-gray-300"}`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-sm font-bold text-gray-800">{pro.rating}</span>
                  <span className="text-sm text-gray-400">({pro.reviews} reviews)</span>
                  <span className="text-gray-300 text-sm">·</span>
                  <span className="text-sm text-gray-500">{pro.years} yrs in business</span>
                </div>

                <div className="flex items-center gap-1.5 text-sm text-gray-500 mb-3">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-[#1B4332]"></i>
                  </div>
                  {pro.location}
                </div>

                <p className="text-sm text-gray-600 leading-relaxed mb-3 line-clamp-2">{pro.description}</p>

                {/* Services */}
                <div className="flex flex-wrap gap-2">
                  {pro.services.map((svc) => (
                    <span key={svc} className="text-xs bg-[#E8F5E9] text-[#1B4332] px-2.5 py-1 rounded-full font-medium whitespace-nowrap">
                      {svc}
                    </span>
                  ))}
                </div>
              </div>

              {/* Right CTA */}
              <div className="flex flex-col items-start md:items-end justify-between gap-3 flex-shrink-0 md:min-w-[160px]">
                <div className="text-right">
                  <p className="text-xs text-gray-400">{pro.responseTime}</p>
                  <p className="text-sm font-bold text-[#1B4332] mt-1">{pro.price}</p>
                </div>
                <button
                  onClick={() => navigate("/free-quote")}
                  className="w-full md:w-auto px-5 py-2.5 bg-[#1B4332] hover:bg-[#2d6a4f] text-white text-sm font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  Request Quote
                </button>
                <button
                  onClick={() => navigate("/free-quote")}
                  className="w-full md:w-auto px-5 py-2 border border-[#1B4332]/30 hover:border-[#1B4332] text-[#1B4332] text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  View Profile
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Load More */}
        {visibleCount < pros.length && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setVisibleCount((c) => Math.min(c + 2, pros.length))}
              className="px-8 py-3 border-2 border-[#1B4332] text-[#1B4332] font-bold text-sm rounded-xl hover:bg-[#1B4332] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Show More Pros
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
